export function getPlaceholder(format: string): string {
  return format.replaceAll(/[a-zA-Z]/g, '_');
}
